/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

const PGW_MESSAGE_TYPE = 'BAANX_INTERNAL_PGW';
const PgwIframe = ({ pgwUrl, onPgwResolve, style }) => {
  const handlePgwState = useCallback((message) => {
    let parsedData;
    try {
      parsedData = JSON.parse(message.data);
    } catch (err) {
      parsedData = message.data;
    }
    const { type, data } = parsedData;
    if (type === PGW_MESSAGE_TYPE) {
      if (onPgwResolve) {
        onPgwResolve(data === 'confirmed');
      }
    }
  }, []);

  useEffect(() => {
    window.addEventListener('message', handlePgwState);

    return () => window.removeEventListener('message', handlePgwState);
  }, []);

  return (
    <div className="iframe-container" style={style}>
      <iframe className="w-100" title="PGW Url" src={pgwUrl} />
    </div>
  );
};

export default PgwIframe;

PgwIframe.propTypes = {
  pgwUrl: PropTypes.string,
  onPgwResolve: PropTypes.func,
  style: PropTypes.object,
};
PgwIframe.defaultProps = {
  pgwUrl: null,
  onPgwResolve: null,
  style: {},
};
